var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25977 6.5L10.2598 9.5L6.25977 12.5M12.2598 12.5H16.2598M4.25977 23.5H22.2598C23.0554 23.5 23.8185 23.1839 24.3811 22.6213C24.9437 22.0587 25.2598 21.2957 25.2598 20.5V4.5C25.2598 3.70435 24.9437 2.94129 24.3811 2.37868C23.8185 1.81607 23.0554 1.5 22.2598 1.5H4.25977C3.46412 1.5 2.70105 1.81607 2.13845 2.37868C1.57584 2.94129 1.25977 3.70435 1.25977 4.5V20.5C1.25977 21.2957 1.57584 22.0587 2.13845 22.6213C2.70105 23.1839 3.46412 23.5 4.25977 23.5Z",
    stroke: "#3A3A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkText);
export default __webpack_public_path__ + "static/media/link-text.d39302ffdba5b77c6c50af62e01ea280.svg";
export { ForwardRef as ReactComponent };